import TagManager from 'react-gtm-module';

import {isNil} from 'ramda';

export function gtmInit() {
  if (isNil(process.env.GTM_CONTAINER_ID) || process.env.ENV_TYPE !== 'prod') {
    return;
  }
  TagManager.initialize({
    gtmId: process.env.GTM_CONTAINER_ID,
  });
}
